const MESSAGES_TYPES = {
  CALL: 'call',
  TEXT: 'text',
  FILE: 'file',
  ADMIN: 'admin',
};

export default MESSAGES_TYPES;
